import { c as _c } from "react/compiler-runtime";
import { IcoUser16 } from '@onefootprint/icons';
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import BaseHoverCard from '../base-hover-card';
import RolePermissions from './role-permissions';
type RoleDisplayProps = {
  isNew?: boolean;
  name: string;
  scopes: TenantScope[];
};
const RoleDisplay = t0 => {
  const $ = _c(14);
  const {
    isNew,
    name,
    scopes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.roles"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let t2;
  if ($[1] !== isNew || $[2] !== name || $[3] !== t) {
    t2 = isNew ? `${t(_temp)} (${name})` : `${name}`;
    $[1] = isNew;
    $[2] = name;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `"${name}" ${t3}`;
  let t5;
  if ($[7] !== name || $[8] !== scopes) {
    t5 = <RolePermissions scopes={scopes} name={name} />;
    $[7] = name;
    $[8] = scopes;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <BaseHoverCard textTrigger={t2} titleText={t4} titleIcon={IcoUser16}>{t5}</BaseHoverCard>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default RoleDisplay;
function _temp($) {
  return $.role;
}
function _temp2($_0) {
  return $_0.rolePermsLower;
}